import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogVisibilityBannerDropdownContentItem from './VeltCommentDialogVisibilityBannerDropdownContentItem/VeltCommentDialogVisibilityBannerDropdownContentItem';
import VeltCommentDialogVisibilityBannerDropdownContentUserPicker from './VeltCommentDialogVisibilityBannerDropdownContentUserPicker/VeltCommentDialogVisibilityBannerDropdownContentUserPicker';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogVisibilityBannerDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-banner-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityBannerDropdownContent.Item = VeltCommentDialogVisibilityBannerDropdownContentItem;
VeltCommentDialogVisibilityBannerDropdownContent.UserPicker = VeltCommentDialogVisibilityBannerDropdownContentUserPicker;
export default VeltCommentDialogVisibilityBannerDropdownContent;
